module.exports = __webpack_public_path__ + "img/Differentiation-LUCA_10X_LU.afdd7cad.png";